import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { loadUserActionByIdFailed, loadUserActionByIdSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* loadUserActivityLogsById(action) {
  try {
    const url = `${BACKEND_URL}/resources/activity-logs/${action.payload}`;
    const dataResponse = yield makeRequest(url, {}, action, 'GET', true);
    if (dataResponse.status === OK) {
      const data = yield dataResponse.json();
      yield put(loadUserActionByIdSuccessful(data.data));
      yield call(resolveActionPromise(action, data.data));
    } else {
      yield put(loadUserActionByIdFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(loadUserActionByIdFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  } finally {
    yield call(resolveActionPromise(action));
  }
}
